import React, { useState, useEffect, useRef } from "react";
import video from "../../assets/portfolio/main.mp4";

// Move textArray outside component to avoid ESLint warnings
const textArray = [
  "Interactive Voice Response",
  "Bulk SMS Services",
  "Business Means Marketing",
  "Seamless Communication Starts with Smarter DeetyaSoft",
];

const Herosection = () => {
  const videoRef = useRef(null);
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (charIndex < textArray[currentTextIndex].length) {
        setDisplayText((prev) => prev + textArray[currentTextIndex][charIndex]);
        setCharIndex((prev) => prev + 1);
      } else {
        clearInterval(interval);
        setTimeout(() => {
          setCharIndex(0);
          setDisplayText("");
          setCurrentTextIndex((prev) => (prev + 1) % textArray.length);
        }, 1500);
      }
    }, 100);
    return () => clearInterval(interval);
  }, [charIndex, currentTextIndex]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch((err) => {
        console.log("Autoplay error:", err);
      });
    }
  }, []);

  return (
    <div className="relative md:h-[86vh] h-[80vh] text-white overflow-hidden">
      {/* Background Video */}
      <video
        ref={videoRef}
        className="absolute top-0 left-0 w-full h-full object-cover z-0"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={video} type="video/mp4" />
      </video>

      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black/50 z-0" />
      {/* Centered Content */}
      <div className="container mx-auto px-6 relative z-10 h-full flex flex-col justify-center items-center text-center">
        <h1 className="md:text-5xl text-2xl font-extrabold text-white mb-4 drop-shadow-md">
          {/* Revolutionize Business Communication */}
          {displayText}
          <span className="text-main animate-pulse">|</span>
        </h1>
        <p className="md:text-2xl text-lg text-white mb-6 opacity-90">
          Revolutionize Business Communication
        </p>
        <button className="border-2 border-white text-white px-6 py-2 rounded-lg transition-all duration-300">
          Get Started
        </button>
      </div>

      {/* Scroll Down Indicator */}
      <div
        onClick={() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth",
          });
        }}
        className="cursor-pointer absolute bottom-6 md:left-[47%] left-[40%] -translate-x-1/2 z-30 animate-bounce flex flex-col items-center"
      >
        <p className="text-white">Scroll Down</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
};

export default Herosection;
